import { Card, CardContent, CardHeader, Divider, FormControlLabel, Radio, Typography } from "@mui/material";
import { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { AbsoluteLoader } from "@common/Loader/AbsoluteLoader";
import { SelectYourNumber } from "@common/SelectYourNumber/SelectYourNumber";
import { NationalDirectoryEnquiriesList, TITLE_INHERIT_STYLE } from "@constants";
import "./css/NationalDirectoryEnquiriesPage.scss";
import { useNDDPreferences } from "./hook/useNDDPreferences";
import { EDirectoryPreferences } from "./interface/INDDPreference";
import { HandleErrorAndLoading } from "@common/HandleErrorAndLoading/HandleErrorAndLoading";

export const NationalDirectoryEnquiriesPage = () => {
    const {
        selectedPreference,
        updateNDDPreference,
        getNDDPreferenceState,
        updateNDDPreferenceState,
        getNDDPreferences,
        isLoading,
    } = useNDDPreferences();

    const { t } = useTranslation(["profile", "common"]);

    return (
        <div className="nationalDirectory">
            <SelectYourNumber>
                <Card className="nationalDirectory-card" elevation={2}>
                    {isLoading && <AbsoluteLoader />}
                    <CardHeader
                        className="card-header card-header__right"
                        title={t("profile:nationalDirectoryEnquiries")}
                        titleTypographyProps={TITLE_INHERIT_STYLE}
                    />
                    <CardContent>
                        <div className="card-header__circle" />
                        <HandleErrorAndLoading
                            error={getNDDPreferenceState.error}
                            isLoading={false}
                            retryFetch={getNDDPreferences}
                        >
                            {updateNDDPreferenceState.error && (
                                <Typography color="error" variant="h5">
                                    {t("common:genericError")}
                                </Typography>
                            )}
                            {NationalDirectoryEnquiriesList.map((NDDPreferenceList, index) => (
                                <Fragment key={NDDPreferenceList.name}>
                                    <FormControlLabel
                                        className="nationalDirectory-card-list"
                                        control={
                                            <Radio
                                                checked={NDDPreferenceList.name === selectedPreference}
                                                color={"secondary"}
                                                name="nationalDirectoryPreferencesList"
                                                value={NDDPreferenceList.name}
                                                onChange={(event) =>
                                                    updateNDDPreference(event.target.value as EDirectoryPreferences)
                                                }
                                            />
                                        }
                                        label={NDDPreferenceList.label}
                                    />
                                    {index !== NationalDirectoryEnquiriesList.length - 1 && <Divider />}
                                </Fragment>
                            ))}
                        </HandleErrorAndLoading>
                    </CardContent>
                </Card>
            </SelectYourNumber>
        </div>
    );
};
